import { GraphRest } from "../rest";
import { User, Users } from "./types";
export { User, Users, People, } from "./types";
Reflect.defineProperty(GraphRest.prototype, "me", {
    configurable: true,
    enumerable: true,
    get: function () {
        return User(this, "me");
    },
});
Reflect.defineProperty(GraphRest.prototype, "users", {
    configurable: true,
    enumerable: true,
    get: function () {
        return Users(this);
    },
});
//# sourceMappingURL=index.js.map